// extracted by mini-css-extract-plugin
module.exports = {"option":"Option_option__wBYu6","focused":"Option_focused__pEnjn"};